import React from 'react';
import T from 'prop-types';

import Button from '../../../../../components/Buttons/Button';

const DownloadExportsButton = ({
  zipUrl,
  disabled = false,
  resetZipUrl,
  selectedExports,
  onMultipleDownload,
}) => {
  if (zipUrl) {
    return (
      <Button variant="green" href={zipUrl} onClick={() => resetZipUrl()}>
        <i className="hicon-download-thin" />
        Ready to Download
      </Button>
    );
  }

  return (
    <Button variant="secondary" disabled={disabled} onClick={onMultipleDownload}>
      <i className="hicon-download-thin" />
      Download {selectedExports.length > 0 ? `${selectedExports.length} exports` : 'all'}
    </Button>
  );
};

DownloadExportsButton.propTypes = {
  zipUrl: T.string,
  disabled: T.bool,
  resetZipUrl: T.func.isRequired,
  onMultipleDownload: T.func.isRequired,
  selectedExports: T.array.isRequired,
};

export default DownloadExportsButton;
